/*
Holds the current CustomerAssociation record for the logged-in session:
*/

export interface CustomerAssociation {
  id: number;
  customerID: number;
  userID: number;
  access: string;
  customerLongName: string;
  customerPreferences: {
    temperatureUnit: string;
    volumeUnit: string;
    densityUnit: string;
    barcodeRegex: string | undefined;
    iwmDashboard: string | undefined;
  };
  customerIntegrationType: string | undefined;
}

export let custInfo: CustomerAssociation | undefined;

export const setCustInfo = (c: CustomerAssociation) => {
  custInfo = c;
};
